(function() {
    'use strict';
    angular.module('emarket.main.profile').controller('PhoneValidationDialogController', ['$q', '$log', '$mdDialog', 'Profile', 'ignoreCall', 'phone', function($q, $log, $mdDialog, Profile, ignoreCall, phone) {
        var vm = this;
        vm.phone = phone.number;

        vm.cancel = function() {
            $mdDialog.cancel();
        };

        vm.validatePhone = function(code) {
            vm.errorMessage = false;
            Profile.validatePhone(phone, code).then(function() {
                $mdDialog.hide();
            }).catch(function(err) {
                vm.errorMessage = err.message;
            });
        };

        vm.resendCode = function() {
            Profile.sendPhoneValidation(phone);
            vm.errorMessage = 'Intentando nuevamente la llamada... por favor conteste';
        };
        var promise;
        if(ignoreCall) {
            promise = $q.when();
        } else {
            promise = Profile.sendPhoneValidation(phone);
        }
        promise.then(function() {
            $log.debug('success');
        }).catch(function(err) {
            $log.error(err);
        });
    }]);

}());
